export interface Multilingual {
  en: string;
  nl: string;
  de: string;
  es: string;
}
